<template>
  <v-tabs
    active-class="white accent--text"
    background-color="transparent"
    class="app-nav"
    v-model="tab"
    centered
    hide-slider
  >
    <template v-for="(tab, key) in tabs">
      <v-tab class="text-none" @click="openRoute(tab)" :key="key">{{
        tab.name
      }}</v-tab>
    </template>
  </v-tabs>
</template>
<script>
import {headerTabs, myCompanyTabs} from "@/assets/constants/nav.constants";
import {mapActions} from "vuex";
import {eventBus} from "@/assets/utils/common.utils";

export default {
  data() {
    return {
      tab: 0,
      whitelist: {
        affiliates: [
          "affiliate-transaction",
          "add-affiliate",
          "update-affiliate",
        ],
        "transaction-history": ["weeklypayout"],
        "dispute-letters": ["copy-dispute-letter", "edit-send-letter"],
        referrals: ["referral", "referral-transaction"]
      },
    };
  },
  computed: {
    tabs() {
      return [...headerTabs].filter((i) => !this.isDisabled(i));
    },
  },
  watch: {
    $route() {
      this.initNavbar();
    },
  },
  methods: {
    ...mapActions("clientFilter", ["resetFilters"]),
    openRoute(tab) {
      if (tab.path === "clients") {
        this.resetFilters();
        eventBus.$emit("resetClientFilter");
      }
      this.$router.replace({ name: tab.path });
    },
    isDisabled({ permission }) {
if (permission == "customers" && this.isAffiliateAuth && this.$route.name != "reset-password") {
        return false;
      }
      if (permission == "my-company") {
        let tab = myCompanyTabs.find((i) => this.hasRead(i.permission));
        return tab == null;
      }
      if (permission == "") return false;
      return !this.hasPermission(permission, "view");
    },
    initNavbar() {
      let name = this.$route?.matched[0]?.name || this.$route.name;
      Object.keys(this.whitelist).forEach((key) => {
        if (this.whitelist[key].indexOf(name) != -1) {
          name = key;
        }
      });
      this.tab = this.tabs.findIndex((i) => i.path == name);
    },
  },
  mounted() {
    this.initNavbar();
  },
};
</script>

<style></style>
